import requestModule from '@/assets/libs/requestModule'
import Util from '@/assets/libs/util'
import CartController from '@/assets/controllers/CartController'

let differentiatedPrices = {}

const getDiffPrices = function () {
  return differentiatedPrices
}

const fetchDiffPrices = async function (clientCode, consumerCode) {
  const requestParams = {
    storeCode: Util.getGeneralInfo().storeCode,
    subsidiaryCode: Util.getGeneralInfo().subsidiaryCode,
    clientCode: clientCode,
    consumerCode: consumerCode
  }

  await requestModule.postRequest('menu/getDifferentiatedPrice', requestParams)
    .then(res => {
      const isValidResponse = res && !res.error && res.data && res.data.length > 0
      differentiatedPrices = isValidResponse ? formatDiffPricesAsObject(res.data) : {}
    })
    .catch((e) => {
      console.log(e)
      differentiatedPrices = {}
    })
}

const formatDiffPricesAsObject = function (diffPrices) {
  try {
    const diffPricesAsObject = {}
    diffPrices.forEach(element => {
      const key = Object.keys(element)[0]
      const value = Object.values(element)[0]
      diffPricesAsObject[key] = value
    })
    return diffPricesAsObject
  } catch (error) {
    console.log(error.message)
    return {}
  }
}

const clearDiffPrices = function () {
  console.log('clearDiffPrices')
  differentiatedPrices = []
  CartController.setAppliedDiffPrices(false)
}

export default {
  getDiffPrices,
  fetchDiffPrices,
  clearDiffPrices
}
